export const invoicePaymentFilter = {
  all: null,
  due: 1,
  paid: 2,
};
